import { z } from 'zod'
import type { PaginatedResponse } from './common'

const baseLessonSchema = z.object({
  course_id: z.string().min(1),
  day_number: z.number().int().positive().optional(),
  title_en: z.string().min(3).max(200),
  title_hi: z.string().min(3).max(200),
  video_url: z.string().url(),
  pdf_url: z.string().url().optional(),
  sort_order: z.number().int().nonnegative().default(0),
  is_published: z.boolean().default(false),
})

export const createLessonSchema = baseLessonSchema
export const updateLessonSchema = baseLessonSchema.partial()

export type CreateLessonInput = z.infer<typeof createLessonSchema>
export type UpdateLessonInput = z.infer<typeof updateLessonSchema>

export type LessonResponse = {
  id: string
  legacy_id?: string | null
  course_id: string
  course_legacy_id?: string | null
  day_number?: number | null
  title_en: string
  title_hi: string
  video_url: string
  pdf_url?: string | null
  sort_order: number
  is_published: boolean
  created_at: string
  updated_at: string
}

export type PublicLessonResponse = {
  id: string
  legacy_id?: string | null
  course_id: string
  course_legacy_id?: string | null
  day_number?: number | null
  title: string
  video_url: string
  pdf_url?: string | null
  sort_order: number
  is_published: boolean
}

export type LessonSortBy = 'sort_order' | 'day_number' | 'created_at'

export type PaginatedLessonResponse = PaginatedResponse<LessonResponse>
export type PaginatedPublicLessonResponse =
  PaginatedResponse<PublicLessonResponse>
